const constantes = {
  tiposNotaDebito: [
    {
      value: "01",
      label: "Transferência de créditos para Cooperativas",
    },
    {
      value: "02",
      label: "Anulação de Crédito por Saídas Imunes/Isentas",
    },
    {
      value: "03",
      label: "Débitos de notas fiscais não processadas na apuração",
    },
    { value: "04", label: "Multa e juros" },
    {
      value: "05",
      label: "Transferência de crédito na sucessão",
    },
    { value: "06", label: "Pagamento antecipado" },
    {
      value: "07",
      label: "Perda em estoque (Perecimento, Perda, Furto, Roubo)",
    },
    { value: "08", label: "Desenquadramento do SN" },
  ],
  tiposNotaCredito: [
    { value: "01", label: "Multa e juros" },
    {
      value: "02",
      label:
        "Apropriação de crédito presumido de IBS sobre o saldo devedor na ZFM (art. 450, § 1º, LC 214/25)",
    },
    {
      value: "03",
      label:
        "Retorno por recusa total na entrega ou por não localização do destinatário na tentativa de entrega",
    },
    { value: "04", label: "Redução de valores" },
    {
      value: "05",
      label: "Transferência de crédito na sucessão",
    },
    { value: "06", label: "Retorno por recusa parcial na entrega" },
  ],
};

export default constantes;
